import { render, staticRenderFns } from "./ProjetoGestaoForm.vue?vue&type=template&id=cc758b4a&"
import script from "./ProjetoGestaoForm.vue?vue&type=script&lang=js&"
export * from "./ProjetoGestaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports